import {Gitlab, Users, MessageCircle, Sunset, ShoppingCart, BookOpen, Info, Send, Twitter, Instagram, DollarSign} from 'react-feather'


export const MENUITEMS = [
    {
        menutitle:"Main Game",
        menucontent:"Play To Earn",
        Items:[
            { path: `${process.env.PUBLIC_URL}/maingame/spaceships`, icon: Gitlab, title: 'Spaceships', type: 'link', active: false },
            { path: `${process.env.PUBLIC_URL}/maingame/workers`, icon: Users, title: 'Workers', type: 'link', active: false},
            { path: `${process.env.PUBLIC_URL}/maingame/mine`, icon: Sunset, title: 'Mine', type: 'link', active: false },
        ]
       
    },

    {
        menutitle:"Marketplace",
        menucontent:"Buy And Sell NFTs",
        Items:[
            { path: `${process.env.PUBLIC_URL}/marketplace/spaceships`, icon: ShoppingCart, title: 'Spaceships', type: 'link', active: false },
            { path: `${process.env.PUBLIC_URL}/marketplace/workers`, icon: ShoppingCart, title: 'Workers', type: 'link', active: false },
        ]
       
    },

    {
        menutitle:"Educate",
        menucontent:"Learn how to play",
        Items:[
            { path: `https://docs.cryptomines.app/`, icon: BookOpen, title: 'Whitepaper', type: 'extLink'},
            { path: `https://docs-es.cryptomines.app/`, icon: BookOpen, title: 'Whitepaper Español', type: 'extLink'},
        ]
       
    },

    {
        menutitle:"Get Social",
        menucontent:"Talk With Us And Other Miners",
        Items:[
            { path: `https://t.me/cryptominesapp`, icon: Send, title: 'Telegram', type: 'extLink'},
            { path: `https://twitter.com/cryptominesapp`, icon: Twitter, title: 'Twitter', type: 'extLink'},
            { path: `https://discord.gg/8Q7cMb3Cqe`, icon: MessageCircle, title: 'Discord', type: 'extLink'},
            { path: `https://www.instagram.com/cryptominesapp`, icon: Instagram, title: 'Instagram', type: 'extLink'},
        ]
       
    },

    {
        menutitle:"Get $ETERNAL",
        menucontent:"with another cryptocurrencies",
        Items:[
            { path: `https://exchange.biswap.org/#/swap?outputCurrency=0xD44FD09d74cd13838F137B590497595d6b3FEeA4`, icon: DollarSign, title: 'Biswap', type: 'extLink'},
            { path: `https://pancakeswap.finance/swap?inputCurrency=BNB&outputCurrency=0xD44FD09d74cd13838F137B590497595d6b3FEeA4`, icon: DollarSign, title: 'PancakeSwap', type: 'extLink'},
        ]
       
    },

    


    
            
]